// extracted by mini-css-extract-plugin
export var baseBrighter = "#FFF";
export var link = "NavigationMenuButton-module--link--793d8";
export var menuButton = "NavigationMenuButton-module--menuButton--ca28b";
export var menuButtonActive = "NavigationMenuButton-module--menuButtonActive--63a90 NavigationMenuButton-module--menuButton--ca28b";
export var textFamily = "var(--textFamily)";
export var theme = "\"@theme.css\"";